import React from "react";
import Common_Title from "../../common/common-title/Common_Title";

const Counselling_Process = ({how_counselling}) => {
  const steps = [
    {
      number: "01",
      title: "Assessment Result Explanation",
      text: "Detailed review of aptitude, personality, and interest outcomes.",
    },
    {
      number: "02",
      title: "Career Stream Discussion",
      text: "Discussion on suitable streams and academic pathways.",
    },
    {
      number: "03",
      title: "Course & College Insights",
      text:
        "Information on courses, eligibility, entrance exams, and colleges.",
    },
    {
      number: "04",
      title: "Structured Career Planning",
      text: "Short-term and long-term academic goal planning.",
    },
    {
      number: "05",
      title: "Personalized Recommendation",
      text:
        "Clear career direction with practical next steps.",
    },
  ];
  
  return (
    <section className="Counselling_Process">
      <div className="container">
        <Common_Title title="How Parental Counselling Works" />

        <div className="process_box_holder">
          <div className="row justify-content-center g-5">
            {how_counselling?.map((step, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6"  key={index}>
                <div className="step_card">
                  <h3 className="step_no">{index+1}</h3>
                  <h5 className="step_title">{step?.name}</h5>
                  <p className="step_text">{step?.description?.replace(/<\/?[^>]+(>|$)/g, "")}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counselling_Process;
